export default {
  title: '生產批次',
  addBatch: '新增生產批次',
  batchInfo: '批次資訊',
  batchInfoPlaceholder: '請輸入批次ID、批次名稱',
  productInfo: '產品資訊',
  productInfoPlaceholder: '請輸入產品名稱',
  productNoLabel: '產品編號：',
  id: 'ID',
  batchName: '批次名稱',
  createTime: '建立時間',
  batchNameLabel: '批次名稱',
  batchNamePlaceholder: '請輸入批次名稱',
  batchNameRequired: '請輸入批次名稱',
  batchNameMax: '最多30個字元',
  relatedProduct: '關聯產品',
  selectSku: '選擇SKU',
  skuPlaceholder: 'SKU',
  productionDate: '生產日期',
  productionDatePlaceholder: '請選擇生產日期',
  productionDateRequired: '請選擇生產日期',
  shelfLife: '保質期',
  shelfLifeRequired: '請選擇保質期類型',
  validityMode: '有效期模式',
  validityModeRequired: '請選擇有效期模式',
  validityModePlaceholder: '請選擇有效期模式',
  validityNum: '有效時間',
  validityNumRequired: '請輸入有效時間',
  validDays: '有效天數',
  validMonths: '有效月數',
  validDate: '有效日期',
  validityYears: '按年份',
  validityLongTerm: '長期有效',
  longTerm: '長期有效',
  validDaysPlaceholder: '請輸入有效天數',
  validDaysRequired: '請輸入有效天數',
  validMonthsPlaceholder: '請輸入有效月數',
  validMonthsRequired: '請輸入有效月數',
  validDatePlaceholder: '請選擇有效日期',
  validDateRequired: '請選擇有效日期',
  validityYearsPlaceholder: '請輸入有效年數',
  relatedProductRequired: '請選擇關聯產品',
  remark: '備註',
  remarkPlaceholder: '請輸入備註',
  factory: '生產工廠',
  inspectionReport: '檢驗報告',
  inspectionReportTip: '請上傳檢驗報告圖片',
  selectProductTitle: '選擇產品',
  productName: '產品名稱',
  productNamePlaceholder: '請輸入產品名稱',
  spec: '規格',
  category: '產品分類',
  retailPrice: '產品零售價',
  select: '選擇',
};
